"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_URI = exports.setApiUri = void 0;
var API_URI = '';
exports.API_URI = API_URI;
var setApiUri = function (uri) {
    if (typeof uri !== 'string') {
        return;
    }
    if (uri.endsWith('/')) {
        uri = uri.substr(0, uri.length - 1);
    }
    exports.API_URI = API_URI = uri;
};
exports.setApiUri = setApiUri;
var predictCost_1 = require("./predictCost");
Object.defineProperty(exports, "predictCost", { enumerable: true, get: function () { return predictCost_1.default; } });
var getBrands_1 = require("./getBrands");
Object.defineProperty(exports, "getBrands", { enumerable: true, get: function () { return getBrands_1.default; } });
var getModels_1 = require("./getModels");
Object.defineProperty(exports, "getModels", { enumerable: true, get: function () { return getModels_1.default; } });
var getGenerations_1 = require("./getGenerations");
Object.defineProperty(exports, "getGenerations", { enumerable: true, get: function () { return getGenerations_1.default; } });
var getYears_1 = require("./getYears");
Object.defineProperty(exports, "getYears", { enumerable: true, get: function () { return getYears_1.default; } });
var getBodies_1 = require("./getBodies");
Object.defineProperty(exports, "getBodies", { enumerable: true, get: function () { return getBodies_1.default; } });
var getModifications_1 = require("./getModifications");
Object.defineProperty(exports, "getModifications", { enumerable: true, get: function () { return getModifications_1.default; } });
var getComplectations_1 = require("./getComplectations");
Object.defineProperty(exports, "getComplectations", { enumerable: true, get: function () { return getComplectations_1.default; } });
